module.exports = {"prices":{"lowestPrice":null}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/prices/hotels/NWI.json
// module id = 79
// module chunks = 119